
import React, { useState, memo, useEffect } from 'react';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import { useLanguage } from '@/contexts/LanguageContext';

interface LayoutProps {
  children: React.ReactNode;
}

// Using memo to prevent unnecessary re-renders
export const Layout: React.FC<LayoutProps> = memo(({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useLanguage();

  // Performance monitoring
  useEffect(() => {
    const startTime = performance.now();
    
    // Register route change performance
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      entries.forEach((entry) => {
        console.log(`Navigation timing: ${entry.name}`, entry);
      });
    });
    
    observer.observe({ entryTypes: ['navigation', 'resource'] });
    
    return () => {
      const endTime = performance.now();
      console.log(`Layout render time: ${endTime - startTime}ms`);
      observer.disconnect();
    };
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar 
        isMobileMenuOpen={isMobileMenuOpen}
        onCloseMobileMenu={() => setIsMobileMenuOpen(false)}
      />
      <div className="flex-1 flex flex-col md:ml-64">
        <Header onMobileMenuToggle={handleMobileMenuToggle} />
        <main className="flex-1 overflow-x-hidden">
          {children}
        </main>
      </div>
    </div>
  );
});

Layout.displayName = 'Layout'; // For React DevTools

export default Layout;
